'use strict';

var Steps = require('./Steps');
Steps.Step = require('./Step');

module.exports = Steps;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.2@rc-steps/lib/index.js
 ** module id = 507
 ** module chunks = 0 1
 **/